import { UserProfileRes } from '../../../api';

import { UserProfile } from './user.abstraction';

export class UserUtils {
  static toProfile(profileResponse: UserProfileRes): UserProfile {
    return {
      adminRoles: profileResponse.adminRoles,
      email: profileResponse.email,
      name: profileResponse.name,
      sub: profileResponse.sub,
      permissions: {
        ...profileResponse.capabilities.admin,
      },
    };
  }
}
